import { BrowserModule,  } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CheckAlreadyLogin, CheckAuth } from './core/guard';
import { AppGlobals } from './app.global';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { QuicklinkModule } from 'ngx-quicklink';
import { ScrollingModule} from '@angular/cdk/scrolling';
import { SharedModule } from './shared/shared.module';
import { loginLayoutComponent } from './layout/login-layout/login-layout.component';
import { LeftSidebarComponent } from './shared/left-sidebar/left-sidebar.component';
import { HeaderComponent } from './shared/header/header.component';
import { FooterComponent } from './shared/footer/footer.component';
import { DataStorage } from './core/helper/data.storage';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ProfileLayoutComponent } from './layout/profile-layout/profile-layout.component';
import { SidebarComponent } from './layout/sidebar/sidebar.component';
import { NavbarComponent } from './layout/navbar/navbar.component';
import { AfterLoginLayoutComponent } from './layout/after-login-layout/after-login-layout.component';
import { ReactiveFormsModule } from '@angular/forms';
import { RequestInterceptor } from './core/helper/request.interceptor';
import { ErrorInterceptor } from './core/helper/error.interceptor';
import { CustomerLayoutComponent } from './layout/customer-layout/customer-layout.component';
import { CustomerNavbarComponent } from './layout/customer-navbar/customer-navbar.component';
import {CONSTANTS} from './core/config/constants';
import { SecondaryFooterComponent } from './shared/secondary-footer/secondary-footer.component';
import { BeforeLoginLayoutComponent } from './layout/before-login-layout/before-login-layout.component';
import { BeforeLoginNavbarComponent } from './layout/before-login-navbar/before-login-navbar.component';
import { DownloadPrintNavbarComponent } from './layout/download-print-navbar/download-print-navbar.component';
import { DownloadPrintLayoutComponent } from './layout/download-print-layout/download-print-layout.component';
import { PendingChangesGuard } from './core/guard/pending-changes.guard';
import { CheckKycActive } from './core/guard/checkKycActive.guard';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { ColorPickerModule } from 'ngx-color-picker';



export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    AfterLoginLayoutComponent,
    BeforeLoginLayoutComponent,
    loginLayoutComponent,
    LeftSidebarComponent,
    HeaderComponent,
    FooterComponent,
    ProfileLayoutComponent,
    SidebarComponent,
    NavbarComponent,
    BeforeLoginNavbarComponent,
    CustomerLayoutComponent,
    CustomerNavbarComponent,
    SecondaryFooterComponent,
    DownloadPrintNavbarComponent,
    DownloadPrintLayoutComponent,
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ToastrModule.forRoot( {timeOut: 10000,
      positionClass: 'toast-top-right',
      preventDuplicates: true}),
    QuicklinkModule,
    ScrollingModule,
    SharedModule,
    HttpClientModule,
    ReactiveFormsModule,
    PdfViewerModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient],
      }
    }),
    ColorPickerModule
  ],
  providers: [AppGlobals, CheckAuth, DataStorage, CheckAlreadyLogin,PendingChangesGuard,CheckKycActive,
    { provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true }
  ],
  bootstrap: [AppComponent],
  exports:[SharedModule,PdfViewerModule]
})

export class AppModule { }
